import { useEffect, useState } from 'react';
import { auth, onAuthStateChanged } from '../auth';
import { adminDiag } from '../utils/adminDiagnostics';

const AUTH_TIMEOUT_MS = 9000;

/**
 * Firebase auth for hidden /admin/* pages — never leaves plain Loading… forever.
 */
export function useAdminPageAuth() {
  const [authReady, setAuthReady] = useState(false);
  const [authTimedOut, setAuthTimedOut] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    adminDiag('admin_auth_listener_started');

    const unsub = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
      setAuthReady(true);
      setAuthTimedOut(false);
      adminDiag('admin_auth_ready');
    });

    const timer = window.setTimeout(() => {
      setAuthReady(true);
      setUser((currentUser) => {
        if (!currentUser) {
          setAuthTimedOut(true);
          adminDiag('admin_auth_timeout');
        }
        return currentUser;
      });
    }, AUTH_TIMEOUT_MS);

    return () => {
      unsub();
      window.clearTimeout(timer);
    };
  }, []);

  return { authReady, authTimedOut, user };
}
